/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Order_1Inputs */

const en_flow_order_1 = /** @type {(inputs: Flow_Order_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The order arrives from Joor, through TIL.`)
};

/**
* | output |
* | --- |
* | "The order arrives from Joor, through TIL." |
*
* @param {Flow_Order_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_order_1 = /** @type {((inputs?: Flow_Order_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Order_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_order_1(inputs)
});